import type { BottomNavigationAction, BottomNavigationDrawerAction } from "@bonusx-global/bx-design-system";
import {
  BoxOutlined,
  EuroCircleDuotone,
  EuroCircleOutlined,
  FileTextEditDuotone,
  FileTextEditOutlined,
  FileWandDuotone,
  FileWandOutlined,
  LogOutDuotone,
  LogOutOutlined,
  MoreHorizontalDuotone,
  MoreHorizontalOutlined,
  MoreHorizontalSolid,
  SettingsDuotone,
  SettingsOutlined,
  UserCircleDuotone,
  UserCircleOutlined,
} from "@bonusx-global/bx-icons";
import {
  EXTERNAL_PATH_COLLECTION,
  LOGOUT_ROUTE,
  PROFILE_PATH,
  REQUESTED_SERVICES_PATH,
  SERVICES_PATH,
  SETTINGS_PATH,
  TOGGLE_BOTTOM_NAVIGATION_DRAWER_ROUTE,
  PRICING_PAGE_PATH,
} from "../../../../constants/env";

export const BOTTOM_NAVIGATION_ROUTES: BottomNavigationAction[] = [
  {
    label: "Profilo",
    icon: <UserCircleOutlined />,
    iconSelected: <UserCircleDuotone />,
    path: PROFILE_PATH,
  },
  {
    label: "Bonus",
    icon: <EuroCircleOutlined />,
    iconSelected: <EuroCircleDuotone />,
    path: SERVICES_PATH,
  },
  {
    label: "Pratiche",
    icon: <FileTextEditOutlined />,
    iconSelected: <FileTextEditDuotone />,
    path: REQUESTED_SERVICES_PATH,
  },
  {
    label: "Upgrade",
    icon: <FileWandOutlined />,
    iconSelected: <FileWandDuotone />,
    path: PRICING_PAGE_PATH,
  },
  {
    label: "Altro",
    icon: <MoreHorizontalSolid />,
    iconSelected: <MoreHorizontalDuotone />,
    path: TOGGLE_BOTTOM_NAVIGATION_DRAWER_ROUTE,
  },
];

export const BOTTOM_NAVIGATION_DRAWER_ROUTES: BottomNavigationDrawerAction[] = [
  {
    label: "Altro",
    icon: <MoreHorizontalOutlined />,
    iconSelected: <MoreHorizontalDuotone />,
    disabled: true,
  },
  {
    label: "Impostazioni",
    icon: <SettingsOutlined />,
    iconSelected: <SettingsDuotone />,
    path: SETTINGS_PATH,
  },
  {
    icon: <BoxOutlined />,
    label: "Scartoffie",
    subpaths: [
      {
        label: "Termini di utilizzo",
        path: EXTERNAL_PATH_COLLECTION.get("terms_of_use"),
      },
      {
        label: "Condizioni Generali di Servizio",
        path: EXTERNAL_PATH_COLLECTION.get("general_conditions_of_service"),
      },
      {
        label: "Privacy Policy",
        path: EXTERNAL_PATH_COLLECTION.get("privacy_policy"),
      },
      {
        label: "Cookies Policy",
        path: EXTERNAL_PATH_COLLECTION.get("cookies_policy"),
      },
    ],
  },
  {
    label: "Logout",
    icon: <LogOutOutlined />,
    iconSelected: <LogOutDuotone />,
    path: LOGOUT_ROUTE,
  },
];
